import React from 'react'

interface DateDividerProps {
  label: string
}

export const DateDivider: React.FC<DateDividerProps> = ({ label }) => {
  return (
    <div className='inbox-date-divider'>
      <div className='inbox-date-line' />
      <span className='inbox-date-label'>{label}</span>
      <div className='inbox-date-line' />
    </div>
  )
}
